/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 30 = ForThirtySeconds 60 = ForOneMinute 300 = ForFiveMinutes 900 = ForFifteenMinutes 1800 = ForThirtyMinutes 3600 = ForOneHour
 */
export type WafRatelimitBlockType = 30 | 60 | 300 | 900 | 1800 | 3600;

export const WafRatelimitBlockType = {
  ForThirtySeconds: 30 as WafRatelimitBlockType,
  ForOneMinute: 60 as WafRatelimitBlockType,
  ForFiveMinutes: 300 as WafRatelimitBlockType,
  ForFifteenMinutes: 900 as WafRatelimitBlockType,
  ForThirtyMinutes: 1800 as WafRatelimitBlockType,
  ForOneHour: 3600 as WafRatelimitBlockType,
};
